/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.3.0-nightly.2026.6.12",
    versionName: "0.3.0-nightly.2026.6.12",
    versionChannel: "nightly",
    buildDate: "2026-06-12T00:42:36.895Z",
    commitHash: "561227970bd0cd07dcee553b31909e1a814793df",
};
